import { useState, useEffect, useRef } from "react";
import MainLayout from "../layouts/MainLayout";
import AppbarSidebarDrawer from "../components/AppbarSidebarDrawer";
import MainContext from "../context/mainContext";
import Login from "../components/user-login/Login";
import VideoPlayer from "../components/mainVideoPlayer/VideoPlayer";
import { splitToWords } from "../components/mainVideoPlayer/utilsFunction";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { getAuthUserinfoApi } from "../services/authApi";
import Grid from "@mui/material/Grid";
import { ToastContainer } from "react-toastify";
import Landing from "./Landing/Landing";
import { isMobile, browserName } from "react-device-detect";

function AppContainer() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [signInBox, setSignInBox] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [videoInfo, setVideoInfo] = useState({
    videoFile: false,
    subtitleOneLanguage: "en",
    subtitleTwoLanguage: "fa",
    subtitleTwoRtl: true,
  });
  const [psVideoPlayer, setPsVideoPlayer] = useState(0);
  const [subtitleTimeShiftBox, setSubtitleTimeShiftBox] = useState(false);
  const [subtitleStylesData, setSubtitleStylesData] = useState({
    sub1_key: "1",
    sub1_subNumber: "اول",
    sub1_hidden: false,
    sub1_name: "1",
    sub1_fontSize: 35,
    sub1_color: "rgba(0, 255, 2, 1)",
    sub1_backGroundColor: "rgba(0, 0, 0, 0.75)",
    sub2_key: "2",
    sub2_subNumber: "دوم",
    sub2_hidden: false,
    sub2_name: "2",
    sub2_fontSize: 35,
    sub2_color: "rgba(246, 255, 0, 1)",
    sub2_backGroundColor: "rgba(0, 0, 0, 0.75)",
    subdict_fontSize: 20,
    subdict_color: "rgba(0, 0, 0, 1)",
  });
  const [subtitleOneContenet, setsubtitleOneContenet] = useState("");
  const [subtitleOneWords, setSubtitleOneWords] = useState({
    allWords: [],
    words: [],
  });
  const [subtitleTwoContenet, setsubtitleTwoContenet] = useState("");
  const [allSubtitleOne, setAllSubtitleOne] = useState([]);
  const [allSubtitleTwo, setAllSubtitleTwo] = useState([]);
  const [lighteMode, setLightMode] = useState(true);
  const [tabSelected, setTabSelected] = useState(true);
  const [oldFullScreenState, setOldFullScreenState] = useState(false);
  const handleFullScreen = useFullScreenHandle();
  const [userWords, setUserWords] = useState({
    userSavedWords: [],
    userLeitnerlearningLevel1: [],
    userLeitnerlearningLevel2: [],
    userLeitnerlearningLevel3: [],
    userLeitnerlearningLevel4: [],
    userLeitnerlearningLevel5: [],
    userLeitnerlearningLevel6: [],
    userLeitnerlearningLevel7: [],
    userLeitnerlearningLevel8: [],
    userLeitnerlearningLevel9: [],
  });
  const [userWordsDifficultyLevel, setUserWordsDifficultyLevel] = useState({
    words: [],
    levels: [],
  });
  const [cferWordsLevel, setCferWordsLevel] = useState({
    words: [],
    levels: [],
  });
  const [checkRpPsPlayer, setCheckRpPsPlayer] = useState(0);
  const [controlVideoPlayer, setControlVideoPlayer] = useState({
    action: "none",
    value: 0,
  });
  const [subWordLearningStyles, setSubWordLearningStyles] = useState({
    co_on: false,
    bk_on: false,
    rp_on: false,
    ps_on: false,
    co_on_1: false,
    co_1: "rgba(0, 255, 2, 1)",
    bk_on_1: false,
    bk_1: "rgba(0, 0, 0, 0.27)",
    rp_1: 0,
    ps_1: 0,
    co_on_2: false,
    co_2: "rgba(0, 255, 2, 1)",
    bk_on_2: false,
    bk_2: "rgba(0, 0, 0, 0.27)",
    rp_2: 0,
    ps_2: 0,
    co_on_3: false,
    co_3: "rgba(0, 255, 2, 1)",
    bk_on_3: false,
    bk_3: "rgba(0, 0, 0, 0.27)",
    rp_3: 0,
    ps_3: 0,
    co_on_4: false,
    co_4: "rgba(0, 255, 2, 1)",
    bk_on_4: false,
    bk_4: "rgba(0, 0, 0, 0.27)",
    rp_4: 0,
    ps_4: 0,
    co_on_5: false,
    co_5: "rgba(0, 255, 2, 1)",
    bk_on_5: false,
    bk_5: "rgba(0, 0, 0, 0.27)",
    rp_5: 0,
    ps_5: 0,
    co_on_6: false,
    co_6: "rgba(0, 255, 2, 1)",
    bk_on_6: false,
    bk_6: "rgba(0, 0, 0, 0.27)",
    rp_6: 0,
    ps_6: 0,
    co_on_7: false,
    co_7: "rgba(0, 255, 2, 1)",
    bk_on_7: false,
    bk_7: "rgba(0, 0, 0, 0.27)",
    rp_7: 0,
    ps_7: 0,
    co_on_8: false,
    co_8: "rgba(0, 255, 2, 1)",
    bk_on_8: false,
    bk_8: "rgba(0, 0, 0, 0.27)",
    rp_8: 0,
    ps_8: 0,
    co_on_9: false,
    co_9: "rgba(0, 255, 2, 1)",
    bk_on_9: false,
    bk_9: "rgba(0, 0, 0, 0.27)",
    rp_9: 0,
    ps_9: 0,
    co_on_10: false,
    co_10: "rgba(0, 255, 2, 1)",
    bk_on_10: false,
    bk_10: "rgba(0, 0, 0, 0.27)",
    rp_10: 0,
    ps_10: 0,
  });
  const [subWordCEFRStyles, setSubWordCEFRStyles] = useState({
    co_on: false,
    co_on: false,
    bk_on: false,
    rp_on: false,
    ps_on: false,
    co_on_1: false,
    co_1: "rgba(0, 255, 2, 1)",
    bk_on_1: false,
    bk_1: "rgba(0, 0, 0, 0.27)",
    rp_1: 0,
    ps_1: 0,
    co_on_2: false,
    co_2: "rgba(0, 255, 2, 1)",
    bk_on_2: false,
    bk_2: "rgba(0, 0, 0, 0.27)",
    rp_2: 0,
    ps_2: 0,
    co_on_3: false,
    co_3: "rgba(0, 255, 2, 1)",
    bk_on_3: false,
    bk_3: "rgba(0, 0, 0, 0.27)",
    rp_3: 0,
    ps_3: 0,
    co_on_4: false,
    co_4: "rgba(0, 255, 2, 1)",
    bk_on_4: false,
    bk_4: "rgba(0, 0, 0, 0.27)",
    rp_4: 0,
    ps_4: 0,
    co_on_5: false,
    co_5: "rgba(0, 255, 2, 1)",
    bk_on_5: false,
    bk_5: "rgba(0, 0, 0, 0.27)",
    rp_5: 0,
    ps_5: 0,
    co_on_6: false,
    co_6: "rgba(0, 255, 2, 1)",
    bk_on_6: false,
    bk_6: "rgba(0, 0, 0, 0.27)",
    rp_6: 0,
    ps_6: 0,
  });

  const [mainPageNumber, setMainPageNumber] = useState(0);
  const pgRef = useRef(0);
  const moreInfoRef = useRef({
    fullScreen: handleFullScreen.active,
    allSubtitleOne,
    subtitleStylesData: subtitleStylesData,
  });
  const [selectVideoBox, setSelectVideoBox] = useState(false);
  const [showSubtitleStyleBox, setShowSubtitleStyleBox] = useState(false);
  const [selectSubtitlesBox, setSelectSubtitlesBox] = useState({
    open: false,
    reset: false,
  });
  const [semiAutoShadowing, setSemiAutoShadowing] = useState({
    showSettings: false,
    on: false,
    shortCut: false,
    startTime: 0,
    endTime: 0,
    repeat: 4,
    showSubsContents: true,
    defaultVolume: 75,
    activeShowSubsContents: false,
    repeatNumber1: { rate: 1, volume: 100, hidden: "show" },
    repeatNumber2: { rate: 0.9, volume: 100, hidden: "undercover" },
    repeatNumber3: { rate: 0.85, volume: 50, hidden: "hidden" },
    repeatNumber4: { rate: 1, volume: 30, hidden: "hidden" },
    repeatNumber5: { rate: 1, volume: 0, hidden: "undercover" },
    repeatNumber6: { rate: 1, volume: 0, hidden: "undercover" },
    repeatNumber7: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber8: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber9: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber10: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber11: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber12: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber13: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber14: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber15: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber16: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber17: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber18: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber19: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber20: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber21: { rate: 1, volume: 0, hidden: "hidden" },
    repeatNumber22: { rate: 1, volume: 0, hidden: "hidden" },
    currentRepeatIndex: 0,
    errData: "",
  });

  const handleSemiAutoShadowing = (type, data, action) => {
    let cpData = { ...semiAutoShadowing };
    let newErr = false;
    if (type.indexOf("repeatNumber") >= 0) {
      cpData[type][action] = data;
    } else if (type == "showSettings") {
      cpData[type] = !cpData[type];
    } else if (type == "shortCut") {
      if (cpData[type]) cpData["on"] = false;
      cpData[type] = !cpData[type];
    } else if (type == "on") {
      if (cpData["startTime"] == 0 || cpData["endTime"] == 0) {
        newErr = "لطفا ابتدا زمان شروع و پایان را مشخص کنید";
      } else if (cpData["startTime"] > cpData["endTime"]) {
        newErr = "زمان شروع نمی تواند پیش از زمان پایان باشد";
      } else {
        if (semiAutoShadowing["showSubsContents"] && data)
          cpData["activeShowSubsContents"] = true;
        cpData["on"] = data;
        cpData["currentRepeatIndex"] = cpData["repeat"];
      }
    } else {
      if (type == "errData") newErr = data;
      else cpData[type] = data;
    }
    if (cpData["endTime"] <= cpData["startTime"]) cpData["on"] = false;
    if (newErr) cpData["errData"] = newErr;
    else cpData["errData"] = "";
    setSemiAutoShadowing(cpData);
    localStorage.setItem("SemiAutoShadowing", JSON.stringify(cpData));
  };

  const handleOpenSelectVideoBox = () => {
    // userTypes.length > 0 ? setSelectVideoBox(true) : handleOpenSignInBox();
    setSelectVideoBox(true);
    handlePageNumber("", 0);
  };

  const handleSubtitleTimeShiftBox = (val) => {
    setSubtitleTimeShiftBox(val);
  };

  const handleCloseSelectVideoBox = (event) => {
    setSelectVideoBox(false);
    if (event === "openSubtitleBox")
      setSelectSubtitlesBox({ open: true, reset: true });
  };
  const handleOpenSelectSubtitlesBox = () => {
    setSelectSubtitlesBox({ open: true, reset: false });
    // handleFullScreen.enter()
  };
  const handleCloseSelectSubtitlesBox = () => {
    setSelectSubtitlesBox({ open: false, reset: false });
  };

  const handleShowSubtitleStyleBox = () => {
    setShowSubtitleStyleBox(!showSubtitleStyleBox);
  };

  const handleSubtitleContenet = (subNumber, content) => {
    if (subNumber == "One") {
      setsubtitleOneContenet(content);
      handleSubtitleOneWords(content);
    } else if (subNumber == "Two") setsubtitleTwoContenet(content);
  };

  const removeSubtitlesTracks = () => {
    let video = document.querySelector("#MainVideo video");
    if (video) {
      let oldTrack2 = document.getElementById("subtitlesTwoTrack");
      if (oldTrack2) video.removeChild(oldTrack2);
      let oldTrack1 = document.getElementById("subtitlesOneTrack");
      if (oldTrack1) video.removeChild(oldTrack1);
    }
    setsubtitleOneContenet("");
    setSubtitleOneWords({
      allWords: [],
      words: [],
    });
    setsubtitleTwoContenet("");
    setAllSubtitleOne([]);
    setAllSubtitleTwo([]);
  };
  const handleSubtitleOneWords = (subtitleOneContenet, styles, levels) => {
    let { allWords, words } = splitToWords(subtitleOneContenet);
    setSubtitleOneWords({ allWords, words });
    setCheckRpPsPlayer(Math.random());
  };

  const handleAllSubtitle = (subNumber, allJsonSub) => {
    if (subNumber == "One") setAllSubtitleOne(allJsonSub);
    else if (subNumber == "Two") setAllSubtitleTwo(allJsonSub);
  };

  const handleUserWords = (data) => {
    setUserWords(data);
  };

  const handleUserWordsDifficultyLevel = (data) => {
    setUserWordsDifficultyLevel(data);
  };

  const handleCferWordsLevel = (data) => {
    setCferWordsLevel(data);
  };

  const handleSubWordLearningStyles = (data) => {
    setSubWordLearningStyles(data);
    localStorage.setItem("SubWordLearningStylesData", JSON.stringify(data));
  };

  const handleSubWordCEFRStyles = (data) => {
    setSubWordCEFRStyles(data);
    localStorage.setItem("SubWordCEFRStyles", JSON.stringify(data));
  };

  const handlePageNumber = (event, newValue) => {
    hadelTabSelected(newValue);
    setMainPageNumber(newValue);
    setControlVideoPlayer({ action: "changePage", value: newValue });
  };
  const handleSubtitleStylesData = (data) => {
    setSubtitleStylesData(data);
    localStorage.setItem("subtitleStylesData", JSON.stringify(data));
  };

  const controlThemeMode = () => {
    setLightMode(!lighteMode);
    localStorage.setItem("themeMode", !lighteMode);
  };

  const hadelTabSelected = (tabnumber) => {
    if (tabnumber == 0) setTabSelected(true);
    else setTabSelected(false);
  };
  const handleUserType = (types) => {
    setUserTypes(types);
  };
  const checkInfoUser = async () => {
    try {
      const userInfo = await getAuthUserinfoApi({});
      if (userInfo) {
        if (userInfo["data"]["data"]["data"]["type_user"])
          setUserTypes(userInfo["data"]["data"]["data"]["type_user"]);
      }
    } catch (error) {}
  };
  function CheckUserSignIn() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      if (token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const typeUser = JSON.parse(jsonPayload)["type"];
        setUserTypes(typeUser);
        checkInfoUser();
      } else {
        // در نسخه نهایی user باید پاک شود
        setUserTypes("");
      }
    } catch {
      // در نسخه نهایی user باید پاک شود
      setUserTypes([""]);
    }
  }

  function CheckInitialMode() {
    try {
      const themeMode = JSON.parse(localStorage.getItem("themeMode"));
      if (themeMode === null) {
        localStorage.setItem("themeMode", true);
        setLightMode(true);
      } else {
        setLightMode(themeMode);
      }
    } catch {
      console.log("Problem in theme Mode");
    }
  }

  function getSubtitleStylesInfo() {
    try {
      const data = JSON.parse(localStorage.getItem("subtitleStylesData"));
      if (data) {
        if (data["sub1_color"]) handleSubtitleStylesData(data);
        else localStorage.removeItem("subtitleStylesData");
      } else {
        console.log("subtitleStyles=default");
      }
    } catch {
      console.log("Problem in SubtitleStylesData");
    }
  }

  function getSubWordLearningStyles() {
    try {
      const data = JSON.parse(
        localStorage.getItem("SubWordLearningStylesData")
      );
      if (data) handleSubWordLearningStyles(data);
      const dataCEFR = JSON.parse(localStorage.getItem("SubWordCEFRStyles"));
      if (dataCEFR) handleSubWordCEFRStyles(dataCEFR);
    } catch {
      console.log("Problem in SubWordLearningStyles");
    }
  }

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((result) => {
        if (result.outcome === "accepted") {
          console.log("User accepted the install prompt");
          localStorage.setItem("installApp", true);
        } else {
          console.log("User dismissed the install prompt");
        }
        setDeferredPrompt(null);
        setShowInstallButton(false);
      });
    }
  };

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const getShadowingValues = () => {
    try {
      const data = JSON.parse(localStorage.getItem("SemiAutoShadowing"));
      if (data) {
        data["activeShowSubsContents"] = false;
        data["on"] = false;
        setSemiAutoShadowing(data);
      }
    } catch {
      console.log("Problem in getShadowingValues");
    }
  };

  useEffect(() => {
    CheckUserSignIn();
    CheckInitialMode();
    getSubtitleStylesInfo();
    getSubWordLearningStyles();
    getShadowingValues();
  }, []);

  useEffect(() => {
    pgRef.current = mainPageNumber;
  }, [mainPageNumber]);

  useEffect(() => {
    moreInfoRef.current = {
      ...moreInfoRef.current,
      ...{ fullScreen: handleFullScreen.active },
    };
  }, [handleFullScreen]);
  useEffect(() => {
    moreInfoRef.current = {
      ...moreInfoRef.current,
      ...{ allSubtitleOne: allSubtitleOne },
    };
  }, [allSubtitleOne]);
  useEffect(() => {
    moreInfoRef.current = {
      ...moreInfoRef.current,
      ...{
        subtitleStylesData: subtitleStylesData,
      },
    };
  }, [subtitleStylesData]);

  const handleOpenSignInBox = () => {
    setOldFullScreenState(handleFullScreen.active);
    setSignInBox(true);
    handleFullScreen.exit();
  };

  const handleCloseSignInBox = () => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!userTypes && token) CheckUserSignIn();
    setSignInBox(false);
    if (oldFullScreenState) handleFullScreen.enter();
  };

  const handleVideoInfo = (videoInfoValue) => {
    setVideoInfo(videoInfoValue);
  };

  return (
    <MainContext.Provider
      value={{
        handleOpenSignInBox,
        handleSubtitleTimeShiftBox,
        subtitleTimeShiftBox,
        handleUserType,
        userTypes,
        handleVideoInfo,
        videoInfo,
        subtitleOneContenet,
        subtitleTwoContenet,
        handleSubtitleContenet,
        userWords,
        handleUserWords,
        userWordsDifficultyLevel,
        handleUserWordsDifficultyLevel,
        subWordLearningStyles,
        handleSubWordLearningStyles,
        handleSubWordCEFRStyles,
        subWordCEFRStyles,
        cferWordsLevel,
        handleCferWordsLevel,
        subtitleOneWords,
        subtitleStylesData,
        handleSubtitleStylesData,
        handlePageNumber,
        handleAllSubtitle,
        allSubtitleOne,
        allSubtitleTwo,
      }}
    >
      <MainLayout lighteMode={lighteMode}>
        {showInstallButton ||
        isMobile ||
        !(browserName == "Edge" || browserName == "Chrome") ? (
          <Landing
            isMobile={isMobile}
            handleInstallClick={handleInstallClick}
            showInstallButton={showInstallButton}
          />
        ) : (
          <>
            <Grid
              container
              direction="column"
              style={{ height: "100%" }}
              sx={{ display: tabSelected ? "flex" : "none" }}
            >
              <FullScreen handle={handleFullScreen}>
                <VideoPlayer
                  selectVideoBox={selectVideoBox}
                  handleCloseSelectVideoBox={handleCloseSelectVideoBox}
                  selectSubtitlesBox={selectSubtitlesBox}
                  handleCloseSelectSubtitlesBox={handleCloseSelectSubtitlesBox}
                  showSubtitleStyleBox={showSubtitleStyleBox}
                  handleShowSubtitleStyleBox={handleShowSubtitleStyleBox}
                  handleFullScreen={handleFullScreen}
                  checkRpPsPlayer={checkRpPsPlayer}
                  controlVideoPlayer={controlVideoPlayer}
                  handleOpenSelectVideoBox={handleOpenSelectVideoBox}
                  handleOpenSelectSubtitlesBox={handleOpenSelectSubtitlesBox}
                  semiAutoShadowing={semiAutoShadowing}
                  handleSemiAutoShadowing={handleSemiAutoShadowing}
                  pgRef={pgRef}
                  signInBox={signInBox}
                  moreInfoRef={moreInfoRef}
                  removeSubtitlesTracks={removeSubtitlesTracks}
                />
              </FullScreen>
            </Grid>
            <Login
              signInBox={signInBox}
              handleCloseSignInBox={handleCloseSignInBox}
              handleUserType={handleUserType}
            />
            <AppbarSidebarDrawer
              mainPageNumber={mainPageNumber}
              controlThemeMode={controlThemeMode}
              handleFullScreen={handleFullScreen}
              handlePageNumber={handlePageNumber}
              handleOpenSelectSubtitlesBox={handleOpenSelectSubtitlesBox}
              handleOpenSelectVideoBox={handleOpenSelectVideoBox}
              handleShowSubtitleStyleBox={handleShowSubtitleStyleBox}
              handleSemiAutoShadowing={handleSemiAutoShadowing}
              removeSubtitlesTracks={removeSubtitlesTracks}
            />
            {handleFullScreen.active ? (
              <></>
            ) : (
              <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
              />
            )}
          </>
        )}
      </MainLayout>
    </MainContext.Provider>
  );
}

export default AppContainer;
